module.exports = __webpack_public_path__ + "media/images/icon-updated-bc192140.svg";